import React from "react";
import { RadialBarChart, RadialBar, PolarAngleAxis, LabelList } from "recharts";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import styles from "./HalfGaugeChart.module.scss";

interface HalfGaugeChartProps {
  currentPoints: number;
  maxPoints: number;
  children?: React.ReactNode;
}

const HalfGaugeChart: React.FC<HalfGaugeChartProps> = ({
  currentPoints,
  maxPoints,
  children,
}) => {
  const data = [
    {
      name: "Points",
      value: currentPoints,
      fill: "#D0A6CD",
    },
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const chartWidth = isMobile ? 360 : 500;
  const chartHeight = isMobile ? 200 : 225;
  const chartCx = isMobile ? 180 : 250;
  const chartCy = isMobile ? 160 : 225;
  const innerRadius = isMobile ? 110 : 180;
  const outerRadius = isMobile ? 125 : 200;

  return (
    <Box className={styles.chartContainer}>
      <RadialBarChart
        width={chartWidth}
        height={chartHeight}
        cx={chartCx}
        cy={chartCy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        barSize={20}
        startAngle={180}
        endAngle={0}
        data={data}
      >
        <PolarAngleAxis
          type="number"
          domain={[0, maxPoints]}
          angleAxisId={0}
          tick={{ fill: "#000", fontSize: 14 }}
          tickCount={Math.ceil(maxPoints / 500) + 1}
        />
        <RadialBar background dataKey="value" cornerRadius={15}>
          <LabelList
            dataKey="value"
            position="insideEnd"
            formatter={(value: number) => `${value} Points`}
          />
        </RadialBar>
      </RadialBarChart>
      {children && <Box className={styles.childrenContainer}>{children}</Box>}
    </Box>
  );
};

export default HalfGaugeChart;
